// @flow
import styled from 'styled-components';

export const RadioInput = styled.input.attrs(({ type = 'radio' }) => ({
  type,
}))``;
